export default "__VITE_ASSET__DevPsmTG__"